var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileExplorer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2627 10.8448C18.9863 10.8448 18.7622 10.6132 18.7622 10.3276V8H12.7555C12.2026 8 11.7544 8.46319 11.7544 9.03448V20.4138C11.7544 20.9851 12.2026 21.4483 12.7555 21.4483H20.2638C20.8167 21.4483 21.265 20.9851 21.265 20.4138V10.8448H19.2627Z",
    fill: "var(--ion-color-secondary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2637 21.4483C20.8165 21.4483 21.2648 20.9851 21.2648 20.4138C21.2648 20.9851 20.8165 21.4483 20.2637 21.4483Z",
    fill: "var(--ion-color-secondary)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0059 12.1379C13.0059 12.4236 13.23 12.6552 13.5064 12.6552C13.2304 12.6543 13.0067 12.4232 13.0059 12.1379Z",
    fill: "var(--ion-color-secondary)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2635 21.4483H19.5127C19.5127 22.3052 20.1851 23 21.0144 23C21.8437 23 22.516 22.3052 22.516 21.4483V20.4138H21.2646C21.2646 20.9851 20.8164 21.4483 20.2635 21.4483Z",
    fill: "var(--ion-background-color)",
    fillOpacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5128 21.4483V13.6897C19.5128 13.1184 19.0645 12.6552 18.5117 12.6552H13.5061C13.2297 12.6552 13.0056 12.4236 13.0056 12.1379V11.6207C13.0056 11.0494 12.5573 10.5862 12.0044 10.5862H9.00111C8.44825 10.5862 8 11.0494 8 11.6207V21.4483C8 22.3052 8.67238 23 9.50167 23H21.0145C20.1852 23 19.5128 22.3052 19.5128 21.4483Z",
    fill: "var(--ion-background-color)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2623 10.8448H21.2645L18.7617 8V10.3276C18.7617 10.6132 18.9858 10.8448 19.2623 10.8448Z",
    fill: "var(--ion-color-secondary)",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5107 9.81035H13.0056C12.8674 9.81035 12.7554 9.69455 12.7554 9.55173C12.7554 9.4089 12.8674 9.29311 13.0056 9.29311H17.5107C17.6489 9.29311 17.7609 9.4089 17.7609 9.55173C17.7609 9.69455 17.6489 9.81035 17.5107 9.81035Z",
    fill: "#121212"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5105 10.8448H14.0066C13.8684 10.8448 13.7563 10.729 13.7563 10.5862C13.7563 10.4434 13.8684 10.3276 14.0066 10.3276H17.5105C17.6487 10.3276 17.7608 10.4434 17.7608 10.5862C17.7608 10.729 17.6487 10.8448 17.5105 10.8448Z",
    fill: "#121212"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.504 21.7069H10.5029C9.81202 21.706 9.25232 21.1277 9.25146 20.4138V19.3793C9.25146 19.2365 9.36353 19.1207 9.50174 19.1207C9.63996 19.1207 9.75202 19.2365 9.75202 19.3793V20.4138C9.75202 20.8423 10.0882 21.1897 10.5029 21.1897H11.504C11.6422 21.1897 11.7542 21.3055 11.7542 21.4483C11.7542 21.5911 11.6422 21.7069 11.504 21.7069Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileExplorer);
export default __webpack_public_path__ + "static/media/file-explorer.77a8f72e.svg";
export { ForwardRef as ReactComponent };